var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Line Rounded/Mark"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.8609 9.07862C16.8609 14.4575 11.3517 17.7712 10.2068 18.4024C10.1434 18.4374 10.0722 18.4557 9.99974 18.4557C9.9273 18.4557 9.85605 18.4374 9.79263 18.4024C8.64688 17.7712 3.1394 14.4575 3.1394 9.07862C3.1394 4.79065 5.71219 1.78906 10.0002 1.78906C14.2881 1.78906 16.8609 4.79065 16.8609 9.07862Z",
    stroke: "#8D8BA7",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.56982 8.65011C6.56982 9.5599 6.93124 10.4324 7.57456 11.0758C8.21788 11.7191 9.09041 12.0805 10.0002 12.0805C10.91 12.0805 11.7825 11.7191 12.4258 11.0758C13.0692 10.4324 13.4306 9.5599 13.4306 8.65011C13.4306 7.74031 13.0692 6.86778 12.4258 6.22446C11.7825 5.58114 10.91 5.21973 10.0002 5.21973C9.09041 5.21973 8.21788 5.58114 7.57456 6.22446C6.93124 6.86778 6.56982 7.74031 6.56982 8.65011V8.65011Z",
    stroke: "#8D8BA7",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMark);
export default __webpack_public_path__ + "static/media/Mark.cc8a139b7ae1f3028a87ce265ab81fd2.svg";
export { ForwardRef as ReactComponent };